import axios from 'axios';
import { handleApiError, performLogout } from '../../../utils/errorHandler';

const API_URL = `${import.meta.env.VITE_API_DOMAIN}:${import.meta.env.VITE_API_PORT}`;

const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});
apiClient.interceptors.response.use(
  (response) => {
    if (response.data) {
      const errorMessage = response.data.errorMessage || response.data.error;
      if (errorMessage) {
        const apiError = handleApiError({ message: errorMessage });
        if (apiError.shouldLogout) {
          performLogout();
          return Promise.reject(new Error(apiError.message));
        }
      }
    }
    return response;
  },
  (error) => {
    const apiError = handleApiError(error);
    if (apiError.shouldLogout) {
      performLogout();
    }
    return Promise.reject(error);
  }
);

export default apiClient;